export default __webpack_public_path__ + "static/media/path_icon.3386360c.svg";